import { render, staticRenderFns } from "./WorkSummary.vue?vue&type=template&id=95ceed1e&scoped=true&"
import script from "./WorkSummary.vue?vue&type=script&lang=js&"
export * from "./WorkSummary.vue?vue&type=script&lang=js&"
import style0 from "./WorkSummary.vue?vue&type=style&index=0&id=95ceed1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ceed1e",
  null
  
)

export default component.exports